var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('svg',{staticClass:"w-100 h-100 world-map",attrs:{"id":"world-map"}},[_c('g',{attrs:{"id":"svg-world"}}),_c('g',{attrs:{"id":"svg-centers"}}),_c('g',{attrs:{"id":"world-label"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }